// extracted by mini-css-extract-plugin
export default {"modal-save-filters":"ModalSaveFilters_modal-save-filters__BXbP5"};